module.exports = __webpack_public_path__ + "5bb848817576d123131ee7bd1074a07c.png";